module.exports = __webpack_public_path__ + "img/logo-white.280ea3a3.svg";